import React, { useEffect } from "react";
import { CourseTaskView, useCourseTask } from "..";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const CourseTaskDetailsMobileView = () => {
  let { courseId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    currentCourseTask,
    courseTaskDetailsQuery,
    courseType,
    updateCourseTasksStatus,
    onStartSimulation,
    modalState,
    onOpenModal,
    onCloseModal,
    studentSpecificDataQuery,
    studentTasks,
    setCurrentCourseTask,
    courseTaskDetails,
  } = useCourseTask({ load: true, courseId });

  const { isPending } = courseTaskDetailsQuery;
  const {
    title,
    taskGroup,
    taskContents,
    taskSections,
    description,
    startDate,
    endDate,
    initialHolding,
    remainingAttempts,
    maxAttempt,
    completionPercentage,
  } = !!courseTaskDetails && courseTaskDetails;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767 && location.pathname.endsWith("/view")) {
        const newPath = location.pathname.replace("/view", "");
        navigate(newPath);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const newCurrent = studentTasks?.find(
      (e) => e?.courseTaskId === currentCourseTask?.courseTaskId
    );
    if (newCurrent) {
      setCurrentCourseTask(newCurrent);
    }
  }, [studentTasks]);

  return (
    <div className="single-page-content mobile-task-view">
      <div className="container">
        <div className="row"></div>
        <CourseTaskView
          title={title}
          isPending={isPending}
          description={description}
          taskGroup={taskGroup}
          taskContents={taskContents}
          taskSections={taskSections}
          courseType={courseType}
          currentCourseTask={currentCourseTask}
          onStartSimulation={onStartSimulation}
          updateCourseTasksStatus={updateCourseTasksStatus}
          modalState={modalState}
          onOpenModal={onOpenModal}
          onCloseModal={onCloseModal}
          studentSpecificDataQuery={studentSpecificDataQuery}
          isMobile={true}
          startDate={startDate}
          initialHolding={initialHolding}
          endDate={endDate}
          maxAttempt={maxAttempt}
          remainingAttempts={remainingAttempts}
          completionPercentage={completionPercentage}
        />
      </div>
    </div>
  );
};
